import { Config, SAM } from '@ccx-public/component-types';
import { initializeSharedAssetModel, Env, DEFAULT_CACHE_KEEP_ALIVE_TTL } from '@ccx-public/shared-asset-model-js';

async function convertConfig(config: Readonly<Config>) {
    if (!config.getAccessToken) {
        throw new Error(
            `Setting CollaborationSDK's Config.getAccessToken is required before using SAM.`
        );
    }

    const accessToken = await config.getAccessToken();
    const { cache_keep_alive_ttl, client_id, user_id } = JSON.parse(
        atob(accessToken.split('.')[1])
    ) as {
        cache_keep_alive_ttl: number | undefined;
        client_id: string;
        user_id: string;
    };

    return [ {
        FEATURE_FLAGS: {
            'use-graphql': config.featureFlags.graphQL,
            'enable-x-bucket-move': config.featureFlags.xBucketMove ?? true, // Express (only sdk consumer) has this enabled by default
            'move-capabilities': {
                'enable-CCI-CCI-move': config.featureFlags.cciToCciMove,
            },
        },
        ACCESS_TOEN: accessToken,
        ENVIRONMENT: config.environment === 'prod' ? Env.Production : Env.Stage,
        CLIENT_ID: client_id,
        USER_ID: user_id,
        LOCALE: config.locale,
        CACHE_KEEP_ALIVE_TTL: cache_keep_alive_ttl ?? DEFAULT_CACHE_KEEP_ALIVE_TTL,
        HIGH_PRIORITY_RAPI_REQUESTS: true,
        HOST_PRODUCT_DATA: {
            PRODUCT_ID: `${config.appName}/${config.appVersion}`,
            PRODUCT_LOCATION: 'CollaborationSDK/unknown',
        },
        // For unsupported properties like ASSET_COPY_NAME_FORMAT
        ...config,
    }, {
        refreshAccessToken: async () => {
            return await config.getAccessToken();
        }
    } ] as const;
}

export const init: SAM.Init = async function (sdkOrConfig) {
    const config
        = 'getConfig' in sdkOrConfig ? sdkOrConfig.getConfig() : sdkOrConfig;

    const sam = await initializeSharedAssetModel(...await convertConfig(config));

    if ('on' in sdkOrConfig) {
        sdkOrConfig.on('change', async () => {
            sam.updateConfig({ LOCALE: config.locale });
        });
    }

    return {
        sam,
    };
};
